import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import {Redirect, Route, Switch} from "react-router-dom";
import MainComponent from "./round-01/main-component";
import PickFood from "./round-01/pick-food";
import PickHousing from "./round-01/pick-housing";
import PickHousingInsurance from "./round-01/pick-housing-insurance";
import PickTransportation from "./round-01/pick-transportation";
import PickTransportationInsurance from "./round-01/pick-transportation-insurance";
import GameComponent from "game/app/components/game/game-component";
import Finalize from "./round-01/finalize";
import Questions from "./round-01/questions";
import Summary from "./round-01/summary";
import {loadQuestions} from "game/app/actions/knowledge-questions";
import VideoBtn from "game/app/components/video-btn";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index.es";


class Round01Node extends GameComponent {

    constructor() {
        super();
        this.state = { selectedCategory: null };
    }

    selectCategory(category) {
        this.setState({...this.state, selectedCategory: category, selectedGroup: null})
    }

    selectGroup(group) {
        this.setState({...this.state, selectedGroup: group})
    }

    pick = () => {
        let instance = this.props.gameInstance.instance;
        this.props
            .sendInput(instance.id, { type: 'pick_family', category: this.state.selectedCategory, name: this.state.selectedGroup })
            .then((result) => {
                this.props.loadQuestions(instance.id);
            });
    };

    render() {
        let instance = this.props.gameInstance.instance;

        if (instance['properties'] && (instance['properties']['PROFILE_KIND'] === undefined || instance['properties']['SETUP_PROFILES'] !== undefined)) {
            let profiles = this.getInstanceProperty('SETUP_PROFILES');
            let categories = {};

            profiles.sort((a,b) => a.id - b.id).forEach((profile) => {
                let category = profile['properties']['category'];
                if (!categories[category])
                    categories[category] = [];
                categories[category].push(profile);
            });

            let categoriesList = Object.keys(categories)
                .map((category, index) => {
                    let selected = category === this.state.selectedCategory;
                    let active = this.state.selectedCategory !== null;
                    let className = ( active ? ( selected ? 'selected' : 'inactive'  ) : '' );
                    return <li key={category} className={className} onClick={() => { this.selectCategory(category) }}>{ category }</li>
                });

            let profilesSelected = this.state.selectedCategory ? categories[this.state.selectedCategory] : [] ;
            let profilesGroups = [];

            profilesSelected.forEach((profile) => {
                let group = profile['properties']['name'];
                if (!profilesGroups[group])
                    profilesGroups[group] = [];
                profilesGroups[group].push(profile);
            });

            let profilesGroupsList = Object.keys(profilesGroups).map((profileName) => {
                let selected = profileName === this.state.selectedGroup;
                let active = this.state.selectedGroup !== null;
                let className = ( active ? ( selected ? 'selected' : 'inactive'  ) : '' );
                return (<li key={profileName} className={className} onClick={() => { this.selectGroup(profileName) }}>{ profileName }</li>);
            });

            return (
                <div className='container'>
                    <div className='row'>
                        <div className={this.mainContainerClass}>
                            <div className='text-center separate-bottom'>
                                <h1 className='page-title separate-bottom'>Výběr domácnosti</h1>
                                <div><VideoBtn videoId='Kvw165nh4YU'/><p></p></div>
                                <p className='label'>Stanovte si domácnost, za kterou budete hrát</p>
                                <p>Vyberte si, jak bude vypadat vaše domácnost. Konkrétní domácnost si pak ze zvolené varianty vylosujete.</p>
                            </div>
                            <div className='card'>
                                <div id="family-picker">
                                    <div className='left-side'>
                                        <div className='title'>Složení domácnosti</div>
                                        <ul>
                                            { categoriesList }
                                        </ul>
                                    </div>
                                    <div className='right-side'>
                                        <div className='title'>Členové domácnosti</div>
                                        { !this.state.selectedCategory && <ul className='text-muted'><li>Zvolte složení domácnosti</li></ul> }
                                        <ul>
                                            { this.state.selectedCategory && profilesGroupsList }
                                        </ul>
                                    </div>
                                </div>
                                <div className='card-body text-center'>
                                    <p className='text-danger'><strong>Pozor, vylosovanou domácnost si nemůžete změnit.<br/>Opravdu chcete domácnost losovat ze zobrazené varianty?</strong></p>
                                    <button onClick={this.pick} disabled={!(this.state.selectedCategory && this.state.selectedGroup)} className='btn btn-primary wide-btn'>Potvrdit výběr</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <Switch>
                <Route path='/game/:instance_id/round-1/bydleni' component={PickHousing}/>
                <Route path='/game/:instance_id/round-1/bydleni-pojisteni' component={PickHousingInsurance}/>
                <Route path='/game/:instance_id/round-1/food' component={PickFood}/>
                <Route path='/game/:instance_id/round-1/transportation' component={PickTransportation}/>
                <Route path='/game/:instance_id/round-1/transportation-pojisteni' component={PickTransportationInsurance}/>
                <Route path='/game/:instance_id/round-1/finalize' component={Finalize}/>
                <Route path='/game/:instance_id/round-1/otazky' component={Questions}/>
                <Route path='/game/:instance_id/round-1/rodina' component={MainComponent}/>
                <Route path='/game/:instance_id/round-1/rozpocet' component={Summary}/>
                <Redirect to={`/game/${this.getInstanceId()}/round-1/rodina`}/>
            </Switch>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        loadQuestions: loadQuestions
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Round01Node);
